var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form-button",class:{ 'disabled-button': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(!_vm.loading)?_c('span',[(_vm.translateText)?[_c('translate',[_vm._v(_vm._s(_vm.text))])]:[_vm._v(_vm._s(_vm.text))]],2):_c('span',[_c('LoadSpinner',{attrs:{"color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }